import { combineReducers } from 'redux';
import { PromotionCodeAction } from '../types';
import { Loadable, Reducer } from '../../../types';
import { PromotionCode } from '../../../../types/items';
import {
  applyPromotionCodeToActiveSubscriptionFail,
  applyPromotionCodeToActiveSubscriptionRequest,
  applyPromotionCodeToActiveSubscriptionSuccess,
} from '../actions';

type State = Loadable<PromotionCode>;
type ReducerOf<T extends keyof State> = Reducer<State, PromotionCodeAction, T>;

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case applyPromotionCodeToActiveSubscriptionRequest.type:
      return true;

    case applyPromotionCodeToActiveSubscriptionSuccess.type:
    case applyPromotionCodeToActiveSubscriptionFail.type:
      return false;

    default:
      return state;
  }
};

const error: ReducerOf<'error'> = (state = false, action) => {
  switch (action.type) {
    case applyPromotionCodeToActiveSubscriptionRequest.type:
    case applyPromotionCodeToActiveSubscriptionSuccess.type:
      return false;

    case applyPromotionCodeToActiveSubscriptionFail.type:
      return true;

    default:
      return state;
  }
};

export default combineReducers({
  loading,
  error,
});
